import { MenuItem, MenuItemProps } from "@mui/material";

export type SHMenuItemProps = MenuItemProps;
export const SHMenuItem = (props: SHMenuItemProps): JSX.Element => (
  <MenuItem {...props} />
);
